import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { AppConfigService } from '@alfresco/adf-core';

import { LocalStorage } from '../shared';
import { SiteConfig } from '../types';
import find from 'lodash/find';
import { UserRepresentation } from '@alfresco/js-api';

@Injectable({
  providedIn: 'root',
})
export class WkAppConfigService {
  get config(): any {
    return this.appConfigService.config;
  }

  get onLoad(): Observable<any> {
    return this.appConfigService.onLoad;
  }

  constructor(private readonly appConfigService: AppConfigService) {}

  public get<T>(key: string, defaultValue?: T): T {
    return this.appConfigService.get(key, defaultValue);
  }

  public getCurrentSiteWorkflowManagerRole(): string[] {
    const currentSiteName = localStorage.getItem(LocalStorage.CURRENT_SITE);
    const sitesConfigs = this.get<SiteConfig[]>('sites');
    const currentSiteConfig = find(sitesConfigs, {
      id: currentSiteName?.toLocaleLowerCase(),
    });
    const defaultSite = find(sitesConfigs, { id: 'default-site' });
    return (currentSiteConfig || defaultSite)?.userGroups.workflowManagerRole;
  }

  public getCurrentSiteAssignWorkflowStepMode(): 'dialog' | 'taskDetail' {
    const currentSiteName = localStorage.getItem(LocalStorage.CURRENT_SITE);
    const sitesConfigs = this.get<SiteConfig[]>('sites');
    const currentSiteConfig = find(sitesConfigs, { id: currentSiteName });
    const defaultSite = find(sitesConfigs, { id: 'default-site' });
    const mode = (currentSiteConfig || defaultSite)?.assignWorkflowStepMode;

    return mode === 'taskDetail' ? 'taskDetail' : 'dialog';
  }

  public apsEnabled(): boolean {
    return this.get<string>('providers') === 'ALL';
  }

  public getIsUserWorkflowManager(apsUser: UserRepresentation): boolean {
    const apsRole = this.getCurrentSiteWorkflowManagerRole();
    return (
      apsUser?.groups?.some((item) => apsRole.includes(item.name || '')) ??
      false
    );
  }
}
